import React, { Component } from 'react'

export default class componentName extends Component {
    render() {
        return (
            <div className="container2">
                <div className="title04">
                    <div className="titleAll">
                        <div className="title04-1" >我们的服务</div>
                        <div className="title04-2">/OUR SERVICE</div>
                    </div>
                    <div className="title04-3">秉持锐意创新,精诚合作的原则,红创科技为多家大型集团、企业提供<br/>
                    了定制化行业技术解决方案.</div>
                </div>
                < div className="companylogo">
                    <img src={require('../image/logo/mengduo.svg')} className="company01"></img>
                    <img src={require('../image/logo/kute.svg')} className="company01"></img>
                    <img src={require('../image/logo/haisibao.svg')} className="company01"></img>
                    <img src={require('../image/logo/longsheng.svg')} className="company01"></img>
                    <img src={require('../image/logo/hair.svg')} className="company01"></img>
                    <img src={require('../image/logo/yutong.svg')} className="company01"></img>
                    <img src={require('../image/logo/haichuanghui.svg')} className="company01"></img>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/fifth.js